/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Labels_Group_NotesInputs */

const en_reading_labels_group_notes = /** @type {(inputs: Reading_Labels_Group_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes and sources`)
};

const es_reading_labels_group_notes = /** @type {(inputs: Reading_Labels_Group_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas y fuentes`)
};

/**
* | output |
* | --- |
* | "Notes and sources" |
*
* @param {Reading_Labels_Group_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_labels_group_notes = /** @type {((inputs?: Reading_Labels_Group_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Labels_Group_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_labels_group_notes(inputs)
	return en_reading_labels_group_notes(inputs)
});